export const defaultSize = {
    width: 620,
    height: 362,
    heightPortrait: 533
};

const minLandscapeWidth = 480; // corresponds to 30em with 16 px font

export function width() {
    if (typeof window === 'undefined') {
        return defaultSize.width;
    }
    return window.innerWidth > 0
        ? Math.min(defaultSize.width, window.innerWidth)
        : defaultSize.width;
}

export function isPortrait() {
    return width() < minLandscapeWidth;
}

export function height() {
    const def = isPortrait() ? defaultSize.heightPortrait : defaultSize.height;
    if (typeof window === 'undefined') {
        return def;
    }
    return window.innerHeight > 0 ? Math.min(def, window.innerHeight) : def;
}

function emToPixels() {
    if (typeof document === 'undefined') {
        return 16;
    }
    const font = getComputedStyle(document.getElementById('root')).fontSize;
    return parseFloat(font || '16');
}

export function widthEm() {
    return width() / emToPixels();
}

export function heightEm() {
    return height() / emToPixels();
}



// WEBPACK FOOTER //
// ./src/utils/size.js